import {
  getWidgetShadowRoot,
  removeScopedStyleTag,
  upsertScopedStyleTag,
} from "../../domStyles";
import { getFeatureTarget } from "../../featureTargets";

const FEATURE_ID = "low-saturation";
const STYLE_ID = "incluway-low-saturation-style";
const CLASS = "incluway-low-saturation";

function getWidgetHtmlEl(): HTMLElement | null {
  const shadowRoot = getWidgetShadowRoot();
  return shadowRoot?.querySelector("html") ?? null;
}

export function enableLowSaturation() {
  document.documentElement.classList.add(CLASS);
  getWidgetHtmlEl()?.classList.add(CLASS);

  upsertScopedStyleTag({
    id: STYLE_ID,
    target: getFeatureTarget(FEATURE_ID, "both"),
    pageCss: `
html.${CLASS} {
  filter: saturate(50%) !important;
}
`.trim(),
    widgetCss: `
html.${CLASS} {
  filter: saturate(50%) !important;
}
`.trim(),
  });
}

export function disableLowSaturation() {
  document.documentElement.classList.remove(CLASS);
  getWidgetHtmlEl()?.classList.remove(CLASS);

  removeScopedStyleTag(STYLE_ID);
}
